import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { AlertInfo } from 'src/app/models/alert-info';
import { IntroducersService } from 'src/app/services/api/introducers.service';
import { ConfirmationDialogService } from 'src/app/services/confirmation-dialog.service';

@Component({
  selector: 'introducer-commission',
  imports: [CommonModule, FormsModule, NgbAlert],
  templateUrl: './introducer-commission.component.html',
  styleUrl: './introducer-commission.component.scss',
})
export class IntroducerCommissionComponent {
  @Input() commissions: any[] = [];
  @Input() introducerId?: number;
  @Output() commissionsChange = new EventEmitter<any[]>();

  alertInfo: AlertInfo = { show: false, type: '', message: '' };
  touchedRows: boolean[] = [];

  constructor(
    private introducersService: IntroducersService,
    private confirmationDialogService: ConfirmationDialogService,
  ) {}

  addCommission(): void {
    const updated = [...this.commissions, { startDate: '', endDate: '', revenuePercent: null }];
    this.commissionsChange.emit(updated);
  }

  confirmDeleteCommission(index: number): void {
    this.confirmationDialogService.open(
      'Are you sure you want to delete this commission?',
      () => this.deleteCommission(index)
    );
  }

  private deleteCommission(index: number): void {
    const commission = this.commissions[index];

    if (this.introducerId && commission.introducerRevenueId) {
      this.introducersService.deleteRevenues(this.introducerId, commission.introducerRevenueId).subscribe({
        next: () => {
          this.showAlertInfo('success', 'Commission deleted successfully');
          const updated = this.commissions.filter((_, i) => i !== index);
          this.commissionsChange.emit(updated);
        },
        error: () => {
          this.showAlertInfo('danger', 'Error deleting commission');
        },
      });
    } else {
      const updated = this.commissions.filter((_, i) => i !== index);
      this.commissionsChange.emit(updated);
    }
  }

  updateField(index: number, field: string, value: any): void {
    this.ensureTouchedRows();
    this.touchedRows[index] = true;
    const updated = this.commissions.map((c, i) =>
      i === index ? { ...c, [field]: value } : c
    );
    this.commissionsChange.emit(updated);
  }

  isFieldInvalid(index: number, field: string): boolean {
    if (!this.touchedRows[index]) return false;
    const value = this.commissions[index]?.[field];
    return value === null || value === undefined || value === '';
  }

  private ensureTouchedRows(): void {
    while (this.touchedRows.length < this.commissions.length) {
      this.touchedRows.push(false);
    }
  }

  showAlertInfo(type: string, message: string): void {
    this.alertInfo = { show: true, type, message };
    setTimeout(() => { this.alertInfo.show = false; }, 3000);
  }
}
